import moment from 'moment';

export const stringToMoment = (stringDate, format) => {
    if (stringDate) {
        return moment(stringDate, format);
    }

    return '';
}